import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { CheckCircle } from 'lucide-react';

interface MilestoneApprovalCompleteModalProps {
  open: boolean;
  onClose: () => void;
  onShowPurchaseAgreement: () => void;
  userRole: 'client' | 'vendor';
}

export function MilestoneApprovalCompleteModal({ 
  open, 
  onClose, 
  onShowPurchaseAgreement,
  userRole 
}: MilestoneApprovalCompleteModalProps) {
  const handleNext = () => {
    if (userRole === 'client') {
      onShowPurchaseAgreement();
    } else {
      onClose();
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <CheckCircle className="h-8 w-8 text-green-500" />
            <AlertDialogTitle>Timeline Approved!</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3">
            <p>
              Both parties have approved the project timeline. 
              {userRole === 'client' ? ' Next, you\'ll need to review and accept the purchase agreement to issue the purchase order.' : ' The client will now create the purchase order to begin work.'}
            </p>
            {userRole === 'vendor' && (
              <p className="text-muted-foreground text-sm">
                You'll be notified once the purchase order is created and work can begin.
              </p>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleNext}>
            {userRole === 'client' ? 'Continue' : 'Got it'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
